import { CosmosTxV1Beta1Tx } from '@injectivelabs/sdk-ts';
export const createCosmosSignDocFromSignDoc = (signDoc) => {
    return CosmosTxV1Beta1Tx.SignDoc.fromPartial({
        bodyBytes: signDoc.bodyBytes,
        authInfoBytes: signDoc.authInfoBytes,
        accountNumber: BigInt(signDoc.accountNumber).toString(),
        chainId: signDoc.chainId,
    });
};
//# sourceMappingURL=cosmos.js.map